import kecabCase from 'lodash/kebabCase'
import Vue from 'vue'

class RegisterGlobalComponentsListener {
	async execute() {
		return new Promise((resolve) => {
			const requireComponent = require.context('../../views/components', true, /[A-Z]\w+\.(vue|js)$/)
			requireComponent.keys().forEach((fileName) => {
				const componentConfig = requireComponent(fileName)
				const fileNameWithoutDotsAndSubfolders = fileName
					.replace(/^\.\/(.*)\.\w+$/, '$1')
					.replace(/(^[a-z]+)(\/)/, '')
				const componentName = kecabCase(fileNameWithoutDotsAndSubfolders)
				Vue.component(componentName, componentConfig.default || componentConfig)
			})
			resolve()
		})
	}
}

export default new RegisterGlobalComponentsListener()
